module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("Copyright © 2022 by Pamela Crane")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("Tabella House")]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("Raleigh, NC")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means including information storage and retrieval systems—except in the case of brief quotations embodied in critical articles or reviews—without written permission.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("The characters and events portrayed in this book are fictitious or are used fictitiously. Any similarity to real persons, living or dead, is purely coincidental and not intended by the author.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("www.pamelacrane.com")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("ISBN: 978-1-940662-244 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "block_5"
  }, [_vm._v("ISBN: 978-1-940662-237 (eBook)")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2",
    attrs: {
      "id": "calibre_pb_3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f64f216c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_002.vue
// module id = 63
// module chunks = 0